const agents = [
{
  id: 'customer-service-orders',
  model_id: 'I7bYg4tC0zPthvt9omJ0',
  name: 'Customer Order Support Agent',
  description: 'Helps customers with order tracking, delivery status, item details, and basic customer support.',
  prompt: `You are a professional, friendly AI assistant working in customer service for an e-commerce company. Your job is to help customers track orders, check delivery status, view order history, and confirm shipping details. Be courteous, clear, and helpful at all times. Start every conversation by saying: "Hi! I’m here to help with your order. What would you like to check today?"`,
  aws_sonic: false,

  data: {
    description: "An online retailer specializing in tools and hardware, offering fast delivery and responsive support.",
    actions: [
      "Look up order status based on order ID, phone number, or email.",
      "Provide delivery dates, tracking numbers, and shipping addresses.",
      "Summarize purchased items and order totals.",
      "Inform if the order has shipped, been delivered, or is still processing.",
     
      "Politely ask for order ID or contact information if not provided."
    ],

    

  },

  tables:{
        ORDERS: [
    {
        "customer_number": "3124234232",
        "customer_name": "Alice Rossi",
        "email": "alice@gmail.com",
        "phone": "393456789012",
        "order_id": "ORD001",
        "date": "2024-12-01",
        "items": ["Cordless Drill", "18V Battery Pack"],
        "total": 159.99,
        "delivery_status": "Delivered",
        "delivery_date": "2024-12-05",
        "delivery_number": "DLV-90821",
        "tracking_number": "IT1234567890",
        "shipping_address": "123 Industrial Ave, Milan, IT"
    },
    {
        "customer_number": "3124234232",
        "customer_name": "Alice Rossi",
        "email": "alice@gmail.com",
        "phone": "393456789012",
        "order_id": "ORD002",
        "date": "2025-01-15",
        "items": ["Adjustable Wrench Set", "Tape Measure"],
        "total": 42.75,
        "delivery_status": "Shipped",
        "delivery_date": "2025-01-19",
        "delivery_number": "DLV-90822",
        "tracking_number": "IT2234567890",
        "shipping_address": "123 Industrial Ave, Milan, IT"
    },
    {
        "customer_number": "3124234234",
        "customer_name": "Luca Bianchi",
        "email": "luca@gmail.com",
        "phone": "393331234567",
        "order_id": "ORD003",
        "date": "2025-02-03",
        "items": ["Corded Angle Grinder", "Protective Goggles"],
        "total": 89.50,
        "delivery_status": "Preparing for Shipment",
        "delivery_date": null,
        "delivery_number": "DLV-90823",
        "tracking_number": null,
        "shipping_address": "78 Workshop Lane, Rome, IT"
    }
]
  }
},

  { 
    id: 'restaurant-demo',
    model_id: 'EXgCBwZRjETqU7vthcPz',
    name: 'Restaurant Concierge Agent',
    description: 'Assists customers with menus, dietary preferences, opening hours, reservations, and real-time table availability.',
    prompt: `You are a professional and courteous AI assistant working for a restaurant. Help customers explore the menu, accommodate dietary preferences, share opening hours, assist with reservations, and provide real-time table availability if requested. Be warm, knowledgeable, and attentive—like a top-tier maître d’. Begin each conversation by saying 'Hello! How can I assist you today?'`,
    aws_sonic:false,
    
data:{
  description: "A modern bar and restaurant in Viterbo offering a fusion of Italian and international cuisines, known for its vibrant atmosphere and signature cocktails.",
  actions:
    [
  "Provide menu, location, and opening hours information.",
  "Make, change, or cancel reservations.",
  "Share details about upcoming events and promotions.",
  "Recommend food and drinks based on preferences or dietary needs.",
  "Answer general customer questions clearly and accurately.",
  "Escalate to staff or provide contact info when unsure."
],
  
  data: [
    "Phone: +39 0761 123456",
    "Email: info@labviterbo.it",
    "Address: Via Roma 10, 01100 Viterbo, Italy"
  ],
  opening_hours: [
    "Monday–Thursday: 12:00–15:00, 18:00–23:00",
    "Friday–Saturday: 12:00–15:00, 18:00–00:00",
    "Sunday: 12:00–15:00, 18:00–23:00"
  ],
  menu: [
    "Starters: Bruschetta al Pomodoro (€6.00), Prosciutto e Melone (€8.00)",
    "Main Courses: Spaghetti alla Carbonara (€12.00), Pollo alla Griglia (€14.00)",
    "Desserts: Tiramisù (€6.00), Panna Cotta (€5.50)",
    "Beverages: Negroni (€7.00), Aperol Spritz (€6.50), Espresso (€1.50)"
  ],
  reservations: [
    "Methods: Phone, Email, Online booking via website",
    "Advance Booking: Recommended for weekends and holidays",
    "Cancellation: Notify at least 24 hours in advance",
    "Group Reservations: Contact directly for groups over 6"
  ],
  events: [
    "Live Jazz Night every Friday evening"
  ]
}
  },
  {
    id: 'sales-agent-demo',
    aws_sonic:true,
    model_id: 'DpC9hJ5OzhzuLmWMZFJO',
    name: 'E-Commerce Sales Assistant',
    description: 'Engages online shoppers, recommends products, answers questions, and helps convert leads into customers.',
    price: 'Starting from 1499,00 EUR',
    prompt: `You are a helpful and persuasive AI sales assistant for an online store. Engage customers by recommending products based on their interests, answering product-related questions, and guiding them smoothly toward purchase. Keep your tone friendly, enthusiastic, and customer-focused, while aiming to convert interest into action.`,
    data: {
  description: "Alex is a vibrant, personable sales consultant at Finbotix, specializing in Conversational AI. He brings energy, strategic insight, and clarity to help businesses unlock real ROI through automation, AI voice agents, and intelligent digital tools.",

  actions: [
    "Engage prospects with a relatable, enthusiastic tone while assessing their goals.",
    "Explain AI solutions clearly and tie them to specific business outcomes.",
    "Offer free demos and guide prospects to the contact form.",
    "Adapt communication style to match client type — analytical, visionary, or pragmatic.",
    "Respond to objections with real examples and ROI-driven insights.",
    "Proactively identify pain points and align them with Finbotix capabilities.",
    "Use light conversational language and affirmations for a natural feel."
  ],

  data: [
    "Company: Finbotix",
    "Solutions: Conversational AI Agents, Document Extraction, AI Email Marketing, Process Automation",
    "Email: contact@finbotix.com",
    "Phone: +1 (800) 555-0199",
    "Website: www dot finbotix dot com",
    "Document Extraction Pricing: $0.01 per page",
    "Use Cases: Customer Support, Document Processing, Marketing Automation, Lead Qualification, Compliance Management",
    "Industries Served: Startups, SMBs, Enterprises across sectors"
  ],

  opening_hours: [
    "Sales Availability: Monday to Friday, 9 AM – 6 PM (Client Time Zone)"
  ],

  menu: [
    "Conversational AI Agents: Real-time, voice-powered interactions with human-like communication and automation.",
    "Intelligent Chatbots: Smart digital assistants that resolve queries and escalate when needed.",
    "Document Extraction: $0.01/page AI-powered data capture from invoices, forms, contracts, and more.",
    "AI Email Marketing: Dynamic, behavior-driven campaigns to drive engagement and conversions.",
    "Process Automation: End-to-end automation of repetitive business workflows to boost efficiency."
  ],

  reservations: [
    "Free Demo: Available on request — just ask or use the contact form.",
    "Consultation: Free 30-minute call to explore fit and business goals.",
    "Contact Form: Located on www dot finbotix dot com for direct follow-up.",
    "Meeting Booking: Use 'schedule_meeting' tool when a time is agreed."
  ],

  events: [
    "Customer Support Automation: Voice agents handle 24/7 queries, reduce costs, and scale support.",
    "Lead Qualification: Chatbots engage visitors, qualify interest, and book meetings instantly.",
    "Invoice Processing: Extract and categorize financial documents in seconds, reducing admin burden.",
    "Compliance Document Handling: Automatically organize regulatory docs and prep for audits.",
    "Order Status Updates: Conversational AI integrated with CRMs to confirm orders and track deliveries.",
    "Marketing Automation: AI email flows triggered by user behavior, increasing engagement and ROI."
  ]
}

  
  },
  {
    id: 'hotel-guest-assistant-demo',
     aws_sonic:false,
    model_id: 'quOx0VjhLN6XfV9A0wck',
    name: 'Hotel Guest Experience Agent',
    description: 'Supports guests with check-in/out, room queries, amenity info, and local attractions—like a 24/7 digital concierge.',
    price: 'Starting from 1799,00 EUR',
    prompt: `You are a digital concierge for a hotel, available 24/7 to support guests. Assist with check-in and check-out info, answer questions about rooms and services, and offer recommendations for local attractions. Your tone should be warm, professional, and welcoming—like a well-trained front desk concierge.`
  },
  {
    id: 'airbnb-host-demo',
     aws_sonic:false,
    model_id: 'UFeqtZm0YBr27rWoGFGh',
    name: 'Airbnb Virtual Host',
    description: 'Provides check-in instructions, Wi-Fi info, area tips, and can escalate to hosts when needed.',
    price: 'Starting from 1599,00 EUR',
    prompt: `You are a friendly virtual Airbnb host. Welcome guests, provide check-in instructions, Wi-Fi details, house rules, and helpful local recommendations. If needed, offer to contact the human host for support. Be informal, helpful, and responsive.`,
  data: {
  description: "A serene ocean-view Airbnb retreat in Malibu offering self check-in, modern amenities, and personalized support for a relaxing stay.",

  actions: [
    "Provide self check-in and checkout instructions.",
    "Explain house rules, quiet hours, and guest policies.",
    "Recommend local dining, beaches, and activities.",
    "Troubleshoot guest issues or direct to emergency contacts.",
    "Answer questions about Wi-Fi, amenities, or parking.",
    "Welcome guests and enhance their stay with helpful tips."
  ],

  data: [
    "Property Name: Sunset Vista Retreat",
    "Location: Malibu, California",
    "Wi-Fi SSID: SunsetVistaWiFi",
    "Wi-Fi Password: OceanView2024!",
    "Emergency (911)",
    "Host Contact: +1-555-123-4567",
    "Maintenance Contact: +1-555-987-6543",
    "Check-in Time: After 3:00 PM",
    "Check-in Method: Self check-in via smart lock",
    "Access Code Info: Sent 24 hours before arrival via Airbnb messaging",
    "Checkout Time: By 11:00 AM",
    "Checkout Instructions: Load the dishwasher and run it",
    "Checkout Instructions: Take out trash to the bins beside the garage",
    "Checkout Instructions: Lock the front door using the smart lock",
    "House Rule: No smoking",
    "House Rule: No pets",
    "House Rule: No parties or events",
    "Quiet Hours: 10:00 PM – 7:00 AM",
    "Maximum Guests: 4"
  ],

  opening_hours: [
    "Check-in: After 3:00 PM",
    "Checkout: By 11:00 AM",
    "Quiet Hours: 10:00 PM – 7:00 AM"
  ],

  menu: [
    "Amenities: Hot tub",
    "Amenities: Private patio",
    "Amenities: BBQ grill",
    "Amenities: Fully equipped kitchen",
    "Amenities: Washer & dryer",
    "Amenities: Ocean view",
    "Amenities: Smart TV with Netflix & Hulu"
  ],

  reservations: [
    "Booking Method: Airbnb only",
    "Early Check-in: Based on availability",
    "Max Guests: 4",
    "Extra Guests: Contact host for special arrangements",
    "Parking: 1 dedicated spot + street parking"
  ],

  events: [
    "Activity: Sunset yoga on the deck",
    "Activity: Whale watching tours (seasonal)",
    "Activity: Wine tasting at local vineyards"
  ]
}

  
  },
  {
    id: 'bb-companion-demo',
     aws_sonic:false,
    model_id: 'quOx0VjhLN6XfV9A0wck',
    name: 'B&B Companion Agent',
    description: 'Assists B&B guests with questions about the property, breakfast options, local attractions, and house rules.',
    price: 'Starting from 1499,00 EUR',
    prompt: `You are a cheerful and informative assistant for a bed & breakfast. Help guests with questions about the property, breakfast times and options, local sightseeing spots, and house policies. Use a cozy and friendly tone.`,
    data: {
  description: "A welcoming B&B assistant for a cozy guesthouse in Lucca, Italy. Helps with bookings, check-in info, local tips, and guest support in a friendly, professional manner.",

  actions: [
    "Assist with reservations, changes, and cancellations.",
    "Provide details on check-in/check-out times and procedures.",
    "Answer questions about amenities, breakfast, Wi-Fi, and house rules.",
    "Share local dining and activity recommendations.",
    "Offer guidance on parking, luggage storage, and pet policies.",
    "Help guests prepare for their stay and enjoy their visit to Lucca."
  ],

  data: [
    "Location: Lucca, Italy",
    "Email: info@examplebnb.com",
    "Phone: +39 0583 000000",
    "Check-In: 3:00 PM to 8:00 PM",
    "Check-Out: By 11:00 AM",
    "Breakfast: Included daily, served 7:30 AM to 10:00 AM",
    "Wi-Fi: Free and available throughout the property",
    "Smoking: Non-smoking indoors; outdoor area available",
    "Pets: Small pets allowed on request; €15 cleaning fee may apply",
    "Quiet Hours: 10:00 PM – 7:00 AM",
    "Parking: Limited private parking €10/day (reservation required); street parking nearby",
    "Luggage Drop-Off: Available before check-in"
  ],

  opening_hours: [
    "Reception: 7:30 AM – 10:00 PM",
    "Check-In: 3:00 PM – 8:00 PM (Late check-in until 10:00 PM with prior notice, €20 fee may apply)",
    "Check-Out: By 11:00 AM"
  ],

  menu: [
    "Breakfast: Fresh pastries, seasonal fruit, local cheeses and cured meats, Italian coffee and teas"
  ],

  reservations: [
    "Booking: Available directly or through partner platforms",
    "Cancellation: Free up to 72 hours before check-in, 50% fee afterward",
    "Payment: Accepted by cash, card, or contactless at check-in",
    "Self Check-In: Secure code/key lockbox available for arrivals outside hours",
    "ID Requirement: Valid ID/passport required at check-in by Italian law"
  ],

  events: [
    "Trattoria da Leo – Traditional Tuscan dishes like tordelli lucchesi",
    "Pizzeria da Felice – Local favorite for rustic pizza and cecina since 1910",
    "L’imbuto – Michelin-starred dining inside the Lucca Contemporary Art Museum",
    "Gelateria De' Coltelli – Artisanal gelato with local ingredients",
    "Walk or bike Lucca’s Renaissance walls – A 4km loop with great views",
    "Climb Torre Guinigi – Tower with oak trees and panoramic city view",
    "Puccini Museum – Birthplace of composer Giacomo Puccini",
    "Explore Piazza dell'Anfiteatro – Roman ruins turned vibrant square",
    "Wine tasting in Montecarlo – 20 min away, with olive oil experiences"
  ]
}

  },
  {
    id: 'virtual-sommelier-demo',
     aws_sonic:false,
    model_id: 'Pp6zSBLj5rpqkHWZ2XEA',
    name: 'Virtual Sommelier',
    description: 'Explains wine origins, food pairings, and taste profiles to help users pick the perfect bottle.',
    price: 'Starting from 1399,00 EUR',
    prompt: `You are a sophisticated virtual sommelier. Help users discover wines by explaining regions, grape varieties, taste notes, and ideal food pairings. Provide guidance based on the occasion and taste preferences. Be elegant, knowledgeable, and engaging.`,
    data: {
  description: "A boutique Italian wine store in Tuscany helping customers choose wines, recommend food pairings, and discover wine stories in a warm and professional way.",

  actions: [
    "Help customers choose wines based on taste, occasion, or food pairing.",
    "Explain wine characteristics, serving temperatures, and ideal storage.",
    "Share fun facts and historical details about wines.",
    "Suggest alternatives for specific wine profiles.",
    "Provide information about business hours and store history.",
    "Assist with shipping, availability, and customer support inquiries."
  ],

  data: [
    "Store Name: La Cantina del Vino",
    "Established: 1995, Tuscany, Italy",
    "Email: info@cantinadelvino.com",
    "Phone: +39 055 1234567",
    "Address: Via del Vino, 10, 50123 Florence, Italy",
    "Shipping: Available in Italy and Europe",
    "Return Policy: No returns on wines, replacements for damaged goods within 7 days",
    "Customer Support: Monday to Friday, 10:00 AM - 7:00 PM"
  ],

  opening_hours: [
    "Monday to Saturday: 10:00 AM – 7:00 PM",
    "Sunday: Closed"
  ],

  menu: [
    "Chianti Classico Riserva (2015) – €25 – 14% – Serve at 16-18°C – Ripe cherry, leather, oak – Pairs with roasted meats, pasta – Fun Fact: From the historical Chianti region.",
    "Brunello di Montalcino (2016) – €50 – 14.5% – Serve at 18-20°C – Dark fruit, tobacco, spices – Pairs with hearty meals – Fun Fact: Made from a Sangiovese clone unique to Montalcino.",
    "Prosecco di Valdobbiadene (NV) – €18 – 11% – Serve at 6-8°C – Apple, citrus, pear – Great as an aperitif – Fun Fact: Produced in the heart of Veneto’s sparkling wine region.",
    "Barolo (2014) – €45 – 14% – Serve at 18-20°C – Rose, tar, strong tannins – Ideal with truffle dishes, aged cheeses – Fun Fact: Known as the King of Wines, with roots in the 12th century.",
    "Pinot Grigio delle Venezie (2020) – €12 – 12.5% – Serve at 8-10°C – Citrus, green apple – Best with seafood, salads – Fun Fact: A white mutation of Pinot Noir, popular in northern Italy."
  ],

  reservations: [
    "Wine Selection: Staff guidance available in-store and via support",
    "Pairing Advice: Personalized food pairing recommendations",
    "Shipping Policy: Available across Italy and Europe",
    "Return Policy: No returns on wine; contact us within 7 days for damaged products",
    "Privacy Policy: Data used only to process orders and assist with wine selection"
  ],

  events: [
    "Fun Fact: Chianti Classico comes from a region dating to the 13th century.",
    "Fun Fact: Brunello was once mistaken for standard Sangiovese before being identified as a unique clone.",
    "Fun Fact: Prosecco’s popularity soared in the 1960s, but its production dates back centuries.",
    "Fun Fact: Barolo was elevated in prestige in the 1800s by the Barolo family.",
    "Fun Fact: Pinot Grigio is genetically related to Pinot Noir and thrives in northern Italy."
  ]
}

  },
  {
    id: 'beer-finder-demo',
     aws_sonic:false,
    name: 'Beer Finder Agent',
    description: 'Recommends beers by flavor, region, and style, with tips on pairing and tasting notes.',
    price: 'Starting from 1299,00 EUR',
    prompt: `You are a casual and friendly beer guide. Help users discover beers based on flavor, region, and type (IPA, stout, lager, etc.). Offer pairing suggestions and explain tasting notes in simple terms. Make it fun and informative!`
  },
  {
    id: 'grocery-helper-demo',
     aws_sonic:false,
    name: 'Grocery Store Helper',
    description: 'Guides customers on products, allergens, recipe ideas, and special offers in real-time.',
    price: 'Starting from 1299,00 EUR',
    prompt: `You are a smart grocery assistant. Help customers find products, check for allergens, suggest recipes, and highlight current offers. Be quick, friendly, and useful like a store employee on-demand.`
  },
  {
    id: 'clinic-scheduler-demo',
     aws_sonic:false,
    name: 'Clinic Appointment Scheduler',
    description: 'Books, reschedules, and confirms appointments while answering basic pre-visit questions.',
    price: 'Starting from 1499,00 EUR',
    prompt: `You are a professional assistant for a medical clinic. Help patients book, reschedule, or confirm appointments. Answer basic questions about services, timings, and what to expect. Keep the tone calm, clear, and empathetic.`
  },
  {
    id: 'fitness-center-assistant-demo',
     aws_sonic:false,
    name: 'Fitness Center Assistant',
    description: 'Answers queries about memberships, schedules, trainers, and helps visitors sign up for classes.',
    price: 'Starting from 1299,00 EUR',
    prompt: `You are a lively fitness center assistant. Provide information about memberships, schedules, personal trainers, and help users book classes. Be energetic, motivational, and clear.`
  }
  ,
  {
    id: 'legal-agent-demo',
     aws_sonic:false,
    name: 'Legal Services Agent',
    description: 'Pre-qualifies clients, shares legal service details, and books consultations for law firms.',
    price: 'Starting from 1599,00 EUR',
    prompt: `You are a polite and informative intake assistant for a law firm. Ask qualifying questions, provide information about legal services, and schedule consultations. Maintain a professional, neutral, and respectful tone.`
  },
  {
    id: 'real-estate-assistant-demo',
    name: 'Real Estate Agent Assistant',
     aws_sonic:true,
    description: 'Handles inquiries about listings, schedules viewings, and answers FAQs on the buying/renting process.',
    price: 'Starting from 1499,00 EUR',
    prompt: `You are a knowledgeable real estate assistant. Help users with questions about properties, schedule viewings, and explain steps in the buying or renting process. Be friendly, accurate, and responsive.`
  }
];

export default agents;
